import _ from 'lodash/fp';

var fp = _.noConflict();

import Ncs from '../index'; // Only the order criteria that have their element present or are independent are valid

function validOrderCriteria(criteria, elementsType, elementsAt) {
  var elementIndependent = fp.isUndefined(criteria.side) && fp.isUndefined(criteria.element);
  var typeIndependent = fp.isUndefined(criteria.type);
  var elementTypeSelected = elementsType === criteria.type;

  if (elementIndependent && typeIndependent) {
    return true;
  } else if (elementIndependent && !typeIndependent) {
    return elementTypeSelected;
  } else {
    var elementPresent = elementsAt(criteria.side, criteria.element);
    return elementTypeSelected && elementPresent;
  }
}

export default {
  namespaced: true,
  state: {
    order: []
  },
  mutations: {
    setDefault: function setDefault(s, resultType) {
      s.order = fp.getOr([], 'order.default', Ncs.config.result[resultType]);
    },
    setOrder: function setOrder(s, o) {
      s.order = fp.clone(o);
    },
    restoreSnapshot: function restoreSnapshot(s, v) {
      s.order = v.order;
    }
  },
  getters: {
    snapshot: function snapshot(s) {
      return {
        order: s.order
      };
    },
    query: function query(s, g, rs, rg) {
      var allowedOrders = fp.getOr([], 'order.orders', Ncs.config.result[rg['api/formResultType']]);
      return fp.pipe(fp.map(function (name) {
        return fp.find({
          name: name
        })(allowedOrders);
      }), fp.flatMap('criteria'), fp.filter(function (o) {
        return validOrderCriteria(o, rs.elements.type, rg['elements/at']);
      }), fp.map(fp.pick(['field', 'asc'])))(s.order);
    },
    options: function options(s, g, rs, rg) {
      var options = fp.getOr([], 'order.orders', Ncs.config.result[rg['api/formResultType']]);
      var validOptions = fp.pipe( // The 'valid' function in an order option allows to show or hide it based on any other state value.
      // This can be used, for example, to show or hide orders based on a subcorpus filter.
      fp.filter(function (o) {
        return !o.valid || o.valid(rs, rg);
      }), // To show an order option it has to have at least one valid order criteria.
      fp.filter(function (o) {
        return fp.some(function (c) {
          return validOrderCriteria(c, rs.elements.type, rg['elements/at']);
        })(o.criteria);
      }))(options);
      return fp.map('name')(validOptions);
    }
  },
  actions: {
    setDefault: function setDefault(_ref) {
      var state = _ref.state,
          dispatch = _ref.dispatch,
          commit = _ref.commit,
          getters = _ref.getters,
          rootGetters = _ref.rootGetters,
          rootState = _ref.rootState;
      commit('setDefault', rootGetters['api/formResultType']);
    },
    reset: function reset(_ref2) {
      var state = _ref2.state,
          dispatch = _ref2.dispatch,
          commit = _ref2.commit,
          getters = _ref2.getters,
          rootGetters = _ref2.rootGetters,
          rootState = _ref2.rootState;
      commit('setDefault', Ncs.config.result.defaultType);
    }
  }
};